import {
  FooterContainer,
  FooterLogo,
  FooterIcon,
  FooterRow,
  FooterImage,
  FooterImageRow,
  FooterTextWrapper,
  FooterInfoContainer,
  FooterIconWrapper,
  FooterColumn,
} from "./FooterStyles";
import { Link, useNavigate } from "react-router-dom";
import { ContentTextWrapper, ContentImage } from "../Contents/ContentStyles";
import {
  faMapMarkerAlt,
  faPhone,
  faEnvelope,
  faLink,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Column, Row } from "../../globalStyles";
import { FooterData } from "../../data/FooterData";

const Footer = () => {
  const navigate = useNavigate();

  const handleClick = (link) => {
    navigate(link);
  };

  return (
    <FooterContainer>
      <FooterRow>
        <FooterLogo mt={"0"} mb={"0"}>
          <FooterIcon
            src="./assets/Kuljetus-ja-Maansiirtoliike-K.-Timonen-Oy-logo.png"
            onClick={() => handleClick("/")}
          />
        </FooterLogo>
        <FooterImageRow
          width={"auto"}
          justify={"stretch"}
          align={"center"}
          background={"rgba(255, 255, 255, 1)"}
        >
          <FooterImage
            src={
              "./assets/RALA_patevyys_RGB-q33tjw5x1xozl1yrx4wz9x7km1e27xjryj5exbj3cg.png"
            }
            width={"clamp(8rem, 1vw, 15rem)"}
            padding={"1rem"}
            border={"none"}
          />
          <FooterImage
            src={
              "./assets/rala_laatu_RGB-q33ttddbyso2ni75kqejx13w8woau26c9fyo4rh6ls.png"
            }
            width={"clamp(8rem, 1vw, 15rem)"}
            padding={"1rem"}
            border={"none"}
          />
          <FooterImage
            src={"./assets/RALA-ymparisto_2/rala_ympäristö_RGB.png"}
            width={"clamp(8rem, 1vw, 15rem)"}
            padding={"1rem"}
            border={"none"}
          />
          <FooterImage
            src={"./assets/rala_turvallisuus_RGB.png"}
            width={"clamp(8rem, 1vw, 15rem)"}
            padding={"1rem"}
            border={"none"}
          />
          <FooterImage
            src={"./assets/SCOPE_2025.png"}
            width={"clamp(8rem, 1vw, 15rem)"}
            padding={"1rem"}
            border={"none"}
          />
          <Row
            width={"auto"}
            justify={"stretch"}
            align={"center"}
            background={"rgba(255, 255, 255, 1)"}
          >
            <Link to={"https://www.maa-aines.com/"}>
              <ContentImage
                src={"./assets/maa-aines-logo.png"}
                cursor={"pointer"}
                width={"clamp(1vw, 10rem, 15rem)"}
                padding={"1rem"}
                border={"none"}
              />
            </Link>
          </Row>
        </FooterImageRow>
        <FooterInfoContainer>
          <FooterColumn>
            <Row justify={"flex-start"} align={"top"} gap="0.5rem">
              <FooterIconWrapper>
                <FontAwesomeIcon icon={faMapMarkerAlt} color="#d90" size="xl" />
              </FooterIconWrapper>
              <FooterTextWrapper href={FooterData[0].link}>
                {FooterData[0].name}: {FooterData[0].text}{" "}
              </FooterTextWrapper>
            </Row>
            <Row justify={"flex-start"} align={"top"} gap="0.5rem">
              <FooterIconWrapper>
                <FontAwesomeIcon icon={faPhone} color="#d90" size="xl" />
              </FooterIconWrapper>
              <FooterTextWrapper href={FooterData[1].link}>
                {FooterData[1].name}: {FooterData[1].text}{" "}
              </FooterTextWrapper>
            </Row>
            <Row justify={"flex-start"} align={"top"} gap="0.5rem">
              <FooterIconWrapper>
                <FontAwesomeIcon icon={faEnvelope} color="#d90" size="xl" />
              </FooterIconWrapper>
              <FooterTextWrapper href={FooterData[2].link}>
                {FooterData[2].name}: {FooterData[2].text}{" "}
              </FooterTextWrapper>
            </Row>
            <Row justify={"flex-start"} align={"top"} gap="0.5rem">
              <FooterIconWrapper>
                <FontAwesomeIcon icon={faLink} color="#d90" size="xl" />
              </FooterIconWrapper>
              <FooterTextWrapper href={FooterData[3].link}>
                {FooterData[3].name}: {FooterData[3].text}{" "}
              </FooterTextWrapper>
            </Row>
          </FooterColumn>
        </FooterInfoContainer>
      </FooterRow>
      <Row justify={"center"}>
        <Link
          to={"/tietosuojaseloste"}
          style={{ textDecoration: "none", color: "white" }}
        >
          <ContentTextWrapper style={{ fontSize: "0.6rem", fontWeight: "400" }}>
            Tietosuojaseloste
          </ContentTextWrapper>
        </Link>
      </Row>
    </FooterContainer>
  );
};

export default Footer;
